import { Directive, ElementRef, OnChanges, inject, input } from '@angular/core';

@Directive({
  selector: '[appNuggetContent]',
  standalone: false,
})
export class NuggetContentDirective implements OnChanges {
  private el = inject<ElementRef<HTMLElement>>(ElementRef);

  readonly appNuggetContent = input<{
    title: string;
    content: string;
  }>(undefined);

  ngOnChanges() {
    const appNuggetContent = this.appNuggetContent();
    if (!appNuggetContent) return;

    this.el.nativeElement.innerHTML = appNuggetContent.content;

    if (!appNuggetContent.title) return;

    const titleEl = document.createElement('span');

    titleEl.classList.add('nugget-content-title');
    titleEl.innerText = appNuggetContent.title + ' ';

    const firstEl = this.el.nativeElement.childNodes[0] as HTMLElement;

    if (firstEl) {
      firstEl.prepend(titleEl);
    } else {
      this.el.nativeElement.prepend(titleEl);
    }
  }
}
